import React, {FC} from "react";
import {StyledDiv, StyledTypography} from "../../providers/layout/LayoutProvider";
import {makeStyles} from "@mui/styles";
import {useConsumerSendMailMutation} from "../../Queries";
import clsx from "clsx";
import {Box, Theme} from "@mui/material";
import {useRecoilValue} from "recoil";
import {DropOffIcon, PackItIcon, TradeInIcon} from "../../svg/SvgIcons";
import {LocalizationsAtom} from "../../providers/localization/LocalizationProvider";
import {LocalizationText} from "../../providers/localization/LocalizationText";
import {isValidEmail} from "../../components/Validations";

export const RoccamorePage: FC<any> = () => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const classes = useStyles({
      leftImage: localizations.frontPageImage1 || "url('https://www.roccamore.com/cdn/shop/files/Bellabootblack01_3f3aef64-be00-4714-9a17-cab922534ddd.png?format=pjpg&v=1688377382&width=400')",
      rightImage: localizations.frontPageImage2 || "url('https://www.roccamore.com/cdn/shop/files/Coco_burgundy_01.jpg?format=pjpg&v=1682927889&width=400')",
   });

   return <div>
      <StyledDiv type={"main"} className={classes.container}>
         <StyledDiv type={"main"} className={clsx(classes.image, classes.leftImage)}>
            &nbsp;
         </StyledDiv>
         <StyledDiv type={"contrast"} className={classes.main} sx={{
            //backgroundImage: 'url("https://www.roccamore.com/cdn/shop/files/roccamore_backgrpund_logo_SD.png?v=1662563893&width=1200")'
         }}>
            <div className={classes.content}>
               <StyledTypography variant={"h1"} type={"contrast"} style={{
                  marginBottom: '26px', color: '#7c7c7c'
               }}>
                  {localizations.loginPageTitle}
               </StyledTypography>
               <LocalizationText text={localizations.loginPageDescription}
                                 typographyProps={{variant: "body1"}}
                                 style={{color: '#7c7c7c'}}
               />
               <LocalizationText text={localizations.loginPageDescription2}
                                 style={{marginTop: '20px', color: '#7c7c7c'}}
                                 typographyProps={{variant: "body1"}}
               />
               <div className={classes.accessForm}>
                  <AccessForm/>
               </div>
            </div>
         </StyledDiv>
         <StyledDiv type={"main"} className={clsx(classes.image, classes.rightImage)}>
            &nbsp;
         </StyledDiv>
      </StyledDiv>
      <RoccamoreEasyBox/>
   </div>
}

type imageProps = {
   leftImage: string
   rightImage: string
}

const useStyles = makeStyles({
   backContainer: {
      marginTop: '20px'
   },
   content: {
      maxWidth: '800px',
      textAlign: 'center'
   },
   container: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      alignItems: 'top',
      padding: '0 0px 0 0px'
   },
   accessForm: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px'
   },
   image: {
      width: '400px',
      minHeight: '496px',
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "top center",
      overflowX: 'hidden',
      overflowY: 'hidden',
   },
   main: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      flexGrow: 1,
      padding: '50px'
   },
   leftImage: {
      backgroundImage: (props: imageProps) => props.leftImage
   },
   rightImage: {
      backgroundImage: (props: imageProps) => props.rightImage
   },
   '@media only screen and (max-width: 900px)': {
      container: {
         flexDirection: 'column',
         padding: '0 23px 0 23px'
      } as any,
      image: {
         width: '100%',
         maxHeight: '200px',
         minHeight: '300px',
         backgroundPosition: "center",
      },
      rightImage: {
         backgroundPosition: "top !important"
      }
   },
})

const AccessForm = () => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const [email, setEmail] = React.useState<string>('');
   const [sent, setSent] = React.useState<boolean>(false);

   const classes = useAccessFormStyles();
   const [sendMail] = useConsumerSendMailMutation();

   const onChange = (event: any) => {
      setEmail(event.target.value);
      setSent(false);
   }

   const onSend = async () => {
      let shopId = window.shopId || window.brandId;
      if (!!email && isValidEmail(email)) {
         await sendMail({
            variables: {
               shopId: shopId,
               mail: email
            }
         });
         setEmail('');
         setSent(true);
      }
   }

   return <>
      <form className={classes.lightBoxInputArea} onSubmit={async (e) => {
         e.preventDefault();
         await onSend();
      }}>
         <Box style={{display: 'flex'}}>
            <input
               style={{
                  boxSizing: "border-box",
                  borderRadius: "0px",
                  padding: "0px 0px 0px 16px",
                  height: "40px",
                  textAlign: "left",
                  color: "rgb(124, 124, 124)",
                  fontFamily: "Montserrat, Verdana, Geneva, sans-serif",
                  fontSize: "12px",
                  fontWeight: 400,
                  letterSpacing: "0px",
                  backgroundColor: "rgb(255, 255, 255)",
                  border: "1px solid rgb(124, 124, 124)",
                  minWidth: '250px'
               }}
               className={"inline-editor input"}
               id="loginemail"
               type="email"
               value={email}
               onChange={onChange}
               placeholder={localizations.mainPageEnterEmail}
               aria-haspopup={false}
               autoComplete={"off"}
               required
            />
            <div className="self-submit-button w3_bg">
               <button style={{padding: '10px'}} type="submit" className="button primary">
                  Send login
               </button>
            </div>
         </Box>
      </form>
      <div className={classes.emailSent}>
         <StyledTypography variant={"body1"} className={classes.emailSentDivider}
                           type={"main"}>{sent ? localizations.mainPageMailSent : ' '}</StyledTypography>
         <StyledTypography variant={"body1"} type={"main"}>{sent ? localizations.mainPageMailSent2: ' '}</StyledTypography>
      </div>
   </>
}


const useAccessFormStyles = makeStyles({
   input: {
      width: '100%',
      height: '45px',
      borderRadius: '20px',
      minWidth: '300px'
   },
   button: {
      height: '45px'
   },
   lightBoxInputArea: {
      display: 'flex',
      alignItems: 'center'
   },
   lightBoxMaxWidth: {
      maxWidth: '60%',
      margin: '0 auto'
   },
   emailSent: {
      marginTop: '20px',
      textAlign: 'center',
      padding: '20px'
   },
   emailSentDivider: {
      marginBottom: '15px'
   },
});


const RoccamoreEasyBox = () => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const classes = useEasyStyles();
   return <div className={classes.container}>
      <div>
         <StyledTypography variant={"h1"} className={classes.title}>
            {localizations.easyBoxTitle}
         </StyledTypography>
      </div>
      <div>
         <div className={classes.list}>
            <div className={classes.listItem}>
               <div className={classes.listAvatar}>
                  <TradeInIcon type={"contrast"}/>
               </div>
               <div className={classes.listText}>
                  <StyledTypography variant={"h2"} className={classes.text}>
                     {localizations.easyBoxSection1Title}
                  </StyledTypography>
                  <StyledTypography variant={"body1"}>
                     {localizations.easyBoxSection1Description}
                  </StyledTypography>
               </div>
            </div>
            <div className={classes.listItem}>
               <div className={classes.listAvatar}>
                  <PackItIcon type={"contrast"}/>
               </div>
               <div className={classes.listText}>
                  <StyledTypography variant={"h2"} className={classes.text}>
                     {localizations.easyBoxSection2Title}
                  </StyledTypography>
                  <StyledTypography variant={"body1"}>
                     {localizations.easyBoxSection2Description}
                  </StyledTypography>
               </div>
            </div>
            <div className={classes.listItem}>
               <div className={classes.listAvatar}>
                  <DropOffIcon type={"contrast"}/>
               </div>
               <div className={classes.listText}>
                  <StyledTypography variant={"h2"} className={classes.text}>
                     {localizations.easyBoxSection3Title}
                  </StyledTypography>
                  <StyledTypography variant={"body1"}>
                     {localizations.easyBoxSection3Description}
                  </StyledTypography>
               </div>
            </div>
         </div>
      </div>
   </div>
}


const useEasyStyles = makeStyles((theme: Theme) => ({
      container: {
         display: 'flex',
         flexDirection: 'column',
         alignItems: 'center'
      },
      title: {
         marginTop: '40px'
      },
      text: {
         marginBottom: '15px'
      },
      list: {
         display: 'flex',
         flexDirection: 'row',
         justifyContent: 'center',
         marginTop: '40px'
      },
      listItem: {
         display: 'flex',
         flexDirection: 'column',
         alignItems: 'center',
         marginBottom: '20px',
         gap: '10px'
      },
      listAvatar: {},
      listText: {
         marginTop: '0',
         textAlign: 'center',
         maxWidth: '400px',
         padding: '0 20px 0 20px'
      },
      '@media only screen and (max-width: 800px)': {
         list: {
            flexDirection: 'column',
         },
         listItem: {
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            maxWidth: '600px',
            gap: '10px'
         },
      }
   }),
);
